/**
 * @typedef {string} tabId
 */

/**
 * SAVR screen tabs
 *
 * @enum {tabId}
 */
export default {
    REQUIREMENTS: 'requirements',
    SERVICE_PROVIDER: 'service-provider',
    COST_COVERAGE: 'cost-coverage',
};
